import React from "react"
import {VisorUsuario} from 'asocomponents'
import NavBar from "../../moleculas/NavBar/NavBar"

export default function Header({menurol}) {
  const user = sessionStorage.getItem('usuario') && JSON.parse(sessionStorage.getItem('usuario'))

  return ( 
    <>
      <NavBar/>
      {menurol&&<VisorUsuario user={user && user.nombreCompleto}/>}
    </>
  )
}
